import { uniq } from 'lodash';
import { IBarChartSeries } from '..';

export const getCategoriesFromSeries = (
  series: IBarChartSeries,
): Array<string | number> =>
  uniq(series.flatMap((s) => s.data.map((d) => d.name)));
